import React, { Component } from 'react';
import './animate.css';
import './App.css';
import Tone from 'tone';

const one_one = new Tone.Player({
  "url": "1_1.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 32.54,
  "volume": 0
}).toMaster();

const one_two = new Tone.Player({
  "url": "1_2.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 32.54,
  "volume": 0
}).toMaster();

const three_one = new Tone.Player({
  "url": "3_1.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 32.54,
  "volume": 0
}).toMaster();

const three_two = new Tone.Player({
  "url": "3_2.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 32.54,
  "volume": 0
}).toMaster();

const four_one = new Tone.Player({
  "url": "4_1.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 32.54,
  "volume": 0
}).toMaster();

const four_two = new Tone.Player({
  "url": "4_2.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 32.54,
  "volume": 0
}).toMaster();

const five_one = new Tone.Player({
  "url": "5_1.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 32.54,
  "volume": 0
}).toMaster();

const five_two = new Tone.Player({
  "url": "5_2.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 32.54,
  "volume": 0
}).toMaster();

const players = [one_one, one_two, three_one, three_two, four_one, four_two, five_one, five_two];

const mainStates = [
  {
    phase0: true,
    phase1_1: false,
    phase1_2: false
  },
  {
    phase0: true,
    phase3_1: false,
    phase3_2: false
  },
  {
    phase0: true,
    phase4_1: false,
    phase4_2: false
  },
  {
    phase0: true,
    phase5_1: false,
    phase5_2: false
  }
];

const phaseBeginStates = [
  {
    phase0: false,
    phase1_2: true,
    phase1_1: false
  },
  {
    phase0: false,
    phase3_2: true,
    phase3_1: false,
  },
  {
    phase0: false,
    phase4_2: true,
    phase4_1: false
  },
  {
    phase0: false,
    phase5_2: true,
    phase5_1: false
  }
];

const phaseToggleStates = [
  [
    {
      phase0: false,
      phase1_2: false,
      phase1_1: true
    },
    {
      phase0: false,
      phase1_2: true,
      phase1_1: false
    }
  ],
  [
    {
      phase0: false,
      phase3_2: false,
      phase3_1: true
    },
    {
      phase0: false,
      phase3_2: true,
      phase3_1: false
    }
  ],
  [
    {
      phase0: false,
      phase4_2: false,
      phase4_1: true
    },
    {
      phase0: false,
      phase4_2: true,
      phase4_1: false
    },
  ],
  [
    {
      phase0: false,
      phase5_2: false,
      phase5_1: true
    },
    {
      phase0: false,
      phase5_2: true,
      phase5_1: false
    }
  ]
];

class App extends Component {

  constructor() {
    super();

    this.state = {
      phase0: true,
      phase3_1: false,
      phase3_2: false
    };

    this.phaseBegin = this.phaseBegin.bind(this);
    this.phaseOneToggle = this.phaseOneToggle.bind(this);
    this.phaseThreeToggle = this.phaseThreeToggle.bind(this);
    this.phaseFourToggle = this.phaseFourToggle.bind(this);
    this.phaseFiveToggle = this.phaseFiveToggle.bind(this);
    this.returnToMain = this.returnToMain.bind(this);
  };

  componentDidMount() {
    console.log("15");
  };

  phaseBegin(i,j,k) {
    this.setState(phaseBeginStates[i]);
    players[j].start();
    players[k].start();
    players[k].mute = true;
  };

phaseOneToggle(i, k) {
    if (this.state.phase1_2 === true) {
      this.setState(phaseToggleStates[i][0]);
      players[k].mute = false;
    };
    if (this.state.phase1_2 === false) {
      this.setState(phaseToggleStates[i][1]);
      players[k].mute = true;
    }
  };

  phaseThreeToggle(i, k) {
    if (this.state.phase3_2 === true) {
      this.setState(phaseToggleStates[i][0]);
      players[k].mute = false;
    };
    if (this.state.phase3_2 === false) {
      this.setState(phaseToggleStates[i][1]);
      players[k].mute = true;
    }
  };

  phaseFourToggle(i, k) {
    if (this.state.phase4_2 === true) {
      this.setState(phaseToggleStates[i][0]);
      players[k].mute = false;
    };
    if (this.state.phase4_2 === false) {
      this.setState(phaseToggleStates[i][1]);
      players[k].mute = true;
    }
  };

phaseFiveToggle(i, k) {
    if (this.state.phase5_2 === true) {
      this.setState(phaseToggleStates[i][0]);
      players[k].mute = false;
    };
    if (this.state.phase5_2 === false) {
      this.setState(phaseToggleStates[i][1]);
      players[k].mute = true;
    }
  };

  returnToMain(i) {
    this.setState(mainStates[i]);
    for (var j = 0; j < players.length; j++) {
      players[j].stop();
    }
  };

  render() {
    return (
      <div className="App">
        <div className="content">
          <div className={this.state.phase0 === true ? "main" : "phase0-hide"}>
            <img className="one_one_image_link" src="blank.png" alt="1" onClick={() => {
              this.phaseBegin(0,0,1);
            }} />
            <img className="three_one_image_link" src="blank.png" alt="3" onClick={() => {
              this.phaseBegin(1,2,3);
            }} />
            <img className="four_one_image_link" src="blank.png" alt="4" onClick={() => {
              this.phaseBegin(2,4,5);
            }} />
            <img className="five_one_image_link" src="blank.png" alt="5" onClick={() => {
              this.phaseBegin(3,6,7);
            }} />
            <img className="exit" src="exit.png" alt="exit" onClick={() => {
              window.location = "../";
            }} />
          </div>
          <div className={this.state.phase1_1 === true ? "one_one" : "phase1_1-hide"}>
            <div className="respiteNavbar animated-slower fadeInAfterPause">
              <img className="respite-img" src="respite.png" alt="respite" onClick={() => {
                this.phaseOneToggle(0,1);
              }} />
              <img className="back-img" src="back.png" alt="back" onClick={() => {
                this.returnToMain(0);
              }} />
            </div>
          </div>
          <div className={this.state.phase1_2 === true ? "one_two" : "phase1_2-hide"}>
            <div className="navbar animated-slow fadeInAfterPause">
              <img className="reminisce-img" src="reminisce.png" alt="reminisce" onClick={() => {
                this.phaseOneToggle(0,1);
              }} />
              <img className="back-img" src="back.png" alt="back" onClick={() => {
                this.returnToMain(0);
              }} />
            </div>
          </div>
          <div className={this.state.phase3_1 === true ? "three_one" : "phase3_1-hide"}>
            <div className="respiteNavbar animated-slower fadeInAfterPause">
              <img className="respite-img" src="respite.png" alt="respite" onClick={() => {
                this.phaseThreeToggle(1,3);
              }} />
              <img className="back-img" src="back.png" alt="back" onClick={() => {
                this.returnToMain(1);
              }} />
            </div>
          </div>
          <div className={this.state.phase3_2 === true ? "three_two" : "phase3_2-hide"}>
            <div className="navbar animated-slow fadeInAfterPause">
              <img className="reminisce-img" src="reminisce.png" alt="reminisce" onClick={() => {
                this.phaseThreeToggle(1,3);
              }} />
              <img className="back-img" src="back.png" alt="back" onClick={() => {
                this.returnToMain(1);
              }} />
            </div>
          </div>
           <div className={this.state.phase4_1 === true ? "four_one" : "phase4_1-hide"}>
            <div className="respiteNavbar animated-slower fadeInAfterPause">
              <img className="respite-img" src="respite.png" alt="respite" onClick={() => {
                this.phaseFourToggle(2,5);
              }} />
              <img className="back-img" src="back.png" alt="back" onClick={() => {
                this.returnToMain(2);
              }} />
            </div>
          </div>
          <div className={this.state.phase4_2 === true ? "four_two" : "phase4_2-hide"}>
            <div className="navbar animated-slow fadeInAfterPause">
              <img className="reminisce-img" src="reminisce.png" alt="reminisce" onClick={() => {
                this.phaseFourToggle(2,5);
              }} />
              <img className="back-img" src="back.png" alt="back" onClick={() => {
                this.returnToMain(2);
              }} />
            </div>
          </div>
           <div className={this.state.phase5_1 === true ? "five_one" : "phase5_1-hide"}>
            <div className="respiteNavbar animated-slower fadeInAfterPause">
              <img className="respite-img" src="respite.png" alt="respite" onClick={() => {
                this.phaseFiveToggle(3,7);
              }} />
              <img className="back-img" src="back.png" alt="back" onClick={() => {
                this.returnToMain(3);
              }} />
            </div>
          </div>
          <div className={this.state.phase5_2 === true ? "five_two" : "phase5_2-hide"}>
            <div className="navbar animated-slow fadeInAfterPause">
              <img className="reminisce-img" src="reminisce.png" alt="reminisce" onClick={() => {
                this.phaseFiveToggle(3,7);
              }} />
              <img className="back-img" src="back.png" alt="back" onClick={() => {
                this.returnToMain(3);
              }} />
            </div>
          </div>
        </div>
      </div>
    );
  };
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js